export const socialsData = {
    github: 'https://github.com/Virsail',
    linkedIn: 'https://www.linkedin.com/in/virsail-mbagaya-893027201/',
    instagram: 'https://www.instagram.com/ad.lip._/',
    twitter: 'https://twitter.com/iSpy28552823',
}